import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <UpdatesSection />
        <IndexSection />
        <AboutSection />
        <ContactSection />
        <CommentsSection />
        <RankingSection />
        <MediaSection />
        <CarouselSection />
        <AppSection />
        <CardsSection />
        <TopicsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}